import { put, call } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import { fetchContacts, fetchInstructions } from "../../api/api";
import {
  fetchHelpInfoFailure,
  fetchHelpInfoSuccess,
} from "src/pages/DashboardPage/gos/store/help/help";

export function* handleFetchHelpInfoSaga(): SagaIterator {
  try {
    const contacts = yield call(fetchContacts);
    const instructions = yield call(fetchInstructions);
    yield put(fetchHelpInfoSuccess({ contacts, instructions }));
  } catch (error) {
    console.error("GOS Help Saga Error:", error);
    yield put(fetchHelpInfoFailure((error as Error).message));
  }
}
